<template>
  <v-dialog v-model="dialog" max-width="680" @click:outside="cancel" :persistent="isLoading">
    <v-card>
      <v-card-title>
        <h3><strong>{{ $t('sitezoneDeleteDialog.label.title') }}</strong></h3>
      </v-card-title>
      <v-card-text>
        {{ $t('sitezoneDeleteDialog.message.confirmDelete', [zoneName]) }}
        <br>
        <v-text style="color: #FF0000;">{{ $t('sitezoneDeleteDialog.message.confirmDeleteAnnotation') }}</v-text>
        <div v-if="errorMessage" class="mt-4" style="color: red">
          {{ errorMessage }}
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel" :disabled="isLoading">{{ $t('common.action.cancel') }}</v-btn>
        <v-btn color="error" text @click="deleteZone" :loading="isLoading">{{ $t('common.action.delete') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/apis/staff";

export default {
  props: {
    dialogData: {
      type: Object,
      required: true,
    },
    handleOk: {
      type: Function,
      required: true,
    },
    handleCancel: {
      type: Function,
      required: true,
    }
  },
  computed: {
    zoneName() {
      return this.dialogData.zone.zoneName;
    }
  },
  data() {
    return {
      dialog: true,
      isLoading: false,
      errorMessage: "",
      errorList: []
    };
  },
  methods: {
    cancel() {
      if (this.isLoading) return;
      this.handleCancel();
    },
    deleteZone() {
      this.isLoading = true;
      this.errorMessage = "";
      this.errorList = [];
      api.post("/zone/delete", {
        siteCode: this.dialogData.zone.siteCode,
        zoneCode: this.dialogData.zone.zoneCode
      })
        .then((response) => {
          if (response.data?.status == 0) {
            this.errorMessage = "";
            this.errorList = [];
            this.handleOk();
          } else {
            this.errorMessage = response.data?.errorMessage || this.$t('sitezoneDeleteDialog.message.deleteFailed');
            this.errorList = response.data?.errorList || [];
          }
        })
        .catch((error) => {
          console.error("Delete zone error:", error);
          // エラー処理
          this.errorMessage = this.$t('common.message.systemError');
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>